import Moderacion from "./Moderacion";

export default Moderacion;
